import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';

export function termsAndConditions(component: any) {
    if (!component) return;

    const {title = '', description = '', entries = []} = component.fields ?? {};
    const entryFields = entries[0]?.fields ?? {};

    return {
        title,
        description,
        alignment: entryFields.alignment ?? '',
        backgroundColor: entryFields.backgroundColor ?? '',
        textColor: entryFields.textColor ?? '',
        componentType: ComponentTypes.TERMSANDCONDITIONS
    };
}
